Profiling.Sessions ||= {}

class Profiling.Sessions.TabView extends Backbone.View
  template: JST['backbone/templates/profiling/sessions/session_tab']
  tagName: 'li'
  className: 'session'

  events:
    'click .tab': 'onClickOnTab'
  #   'click .badge': 'onUpdateContentsCount'
    'click #minimize_tab': 'onMinimizeTab'
    'click #minimize_tab_new_session': 'onMinimizeNewTab'
  # 'click #minimize_tab_drill_down': 'onMinimizeNewTab'
  #   'click .copy_session_from_tab': 'copySession'
  #   'click .clone_session_from_tab': 'cloneSession'
  #   'click .remove_session_from_tab': 'removeSession'
    'click .rename_session_from_tab': 'renameSession'
    'mouseleave ul.dropdown-menu' : 'onMouseLeaveDropdownMenu'
    'click .dropdown': 'onClickMenu'

  initialize: (@options = {}) ->
    @dashboard = @options.dashboard
    @listenTo @dashboard, 'new_search', ({mode}) =>
      @sessionMode = mode
      @$el.find('.mode-icon').addClass(@_iconClassByMode(@sessionMode))
    @is_new_tab = false
    @sessionsView = @options.sessionsView
    if `this.dashboard.searchQuery == null` then @is_new_tab = true
    @name = @options.name or I18n.t('monitoring.dashboard.session.tab.placeholder')
    @_renameTooltip(@name)
    @id = "minimize_tab"
    @isNewSession = @name == I18n.t('monitoring.dashboard.session.tab.placeholder')
    @id += '_new_session' if @isNewSession
    @id += "_drill_down" if @name == "Drill Down"
    @eventAggregator.bind('onNewRealtimeContent', @onNewRealtimeContent)
    @eventAggregator.bind('contentReceived', @onContentReceived)
    @eventAggregator.bind('myHistorySessionCreated', @onMyHistorySessionCreated)
    @isActivated = false

  onClickOnTab: =>
    if !@isActivated
      if @dashboard.isReviewMode()
        $('.monitoring-dashboard').addClass('review').removeClass('explore')
      else
        $('.monitoring-dashboard').addClass('explore').removeClass('review')
      @eventAggregator.trigger('clickOnTab', this)
    window.scrollTo(0, 0)

  onMinimizeTab: (event, updateServer = true) =>
    event.stopPropagation()
    @eventAggregator.trigger('clickOnMinimizeTab', @, updateServer)

  onMinimizeNewTab: (event) =>
    if @$el.find('#name').text() == I18n.t('monitoring.dashboard.session.tab.placeholder')
      @onMinimizeTab(event, false)
    else if @$el.find('#name').text() == "Drill Down"
      @eventAggregator.trigger('clickOnMinimizeAndRemoveSession', this)
    else
      swal({
          title: I18n.t('monitoring.dashboard.session.tab.title'),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: I18n.t('monitoring.dashboard.session.tab.confirm'),
          confirmButtonClass: "btn-info"
          cancelButtonText: I18n.t('monitoring.dashboard.session.tab.cancel'),
          cancelButtonColor: "#DD6B55"
          closeOnConfirm: true,
          closeOnCancel: true
        }, (isSaved) =>
          if isSaved
            event.stopPropagation()
            @eventAggregator.trigger('clickOnMinimizeTab', this)
          else
            @eventAggregator.trigger('clickOnMinimizeAndRemoveSession', this)
      )

  onClickMenu: ->
    buttonContainer = @$el.find('.dropdown.tab-menu-button-container')
    dropdownToggle = @$el.find(".dropdown-toggle")
    dropdownMenu = @$el.find(".dropdown-menu")
    dropdownMenu.css({
      "top": (dropdownToggle.position().top + dropdownToggle.outerHeight()) + "px",
      "left": dropdownToggle.position().left + "px"
    });

  onContentReceived: (uuid) =>
    if @dashboard.uuid == uuid
      @$el.find('i.badge').html('').hide()

  onNewRealtimeContent: (uuid, counter) =>
    if @dashboard.uuid == uuid
      @$el.find('i.badge').html(counter).show()

  onMyHistorySessionCreated: (uuid) =>
    if @dashboard.uuid == uuid
      window.myHistoryCreated = true
      @eventAggregator.trigger('addNewTab')
      @eventAggregator.trigger('clickOnMinimizeTab', this)

  render: =>
    @$el.append(jQuery.parseHTML(@template(
      name: @name
      id: @id
      is_new_tab: @is_new_tab
      isNewSession: @isNewSession
    )))
    @_renameTooltip(@name)
    return this

  updateCount: (total) ->
    if @dashboard.isReviewMode()
      @$el.find('i.badge').html(total).show()
      @onUpdateContentsCount() if @dashboard.isReviewMode()

  rename: (newName) ->
    oldName = @name
    @setName(newName)
    onError = () =>
      @setName(oldName)
    options = @_getEditableOptions();
    dataToSend =
      value: newName
      pk: options.pk
    onSuccess = (response, msg) =>
      options.success(response, newName)
      @re_render(newName)
    $.ajax(
      type: 'POST',
      url: options.url,
      data: dataToSend,
      error: onError,
      success: onSuccess
    )

  setName: (newName) ->
    @name = newName
    parsedName = @name
    dateName = Date.create parsedName
    parsedName = dateName.format('DD-MM-YYYY HH:mm:ss') if dateName.getTime()
    @_renameTooltip(@name)
    @reRenderTitle(parsedName)

  _renameTooltip: (name) ->
    return unless name and name.trim() != ''
    @$el.find('.tab').tooltip('hide').attr('data-original-title', name.trim()).tooltip('fixTitle')

  reRenderTitle: (name) =>
    @$el.find('#name').text(name)

  re_render: (name) =>
    @$el.html(@template(
      name: name
      id: @id
      is_new_tab: false
      isNewSession: @isNewSession
    ))
    @$el.find('.mode-icon').addClass(@_iconClassByMode(@sessionMode))
    @

  resize: ->
    throw "Monitoring.Views.SocialContents.SessionTabView.resize() deprecated"

  _getEditableOptions: ->
    return {
      type: 'text',
      pk: @getUuid(),
      display: @reRenderTitle,
      value: @name,
      toggle: 'manual',
      url: '/profiling/dashboard/rename.json',
      title: I18n.t('monitoring.dashboard.session.tab.enter_name'),
      placement: 'bottom',
      success: (response, newValue) =>
        if !response.success
          return response.msg
        else
          @eventAggregator.trigger('sessionListChange')
          @_renameTooltip(newValue)
    }

  activate: ->
    @dashboard.activate()
    @isActivated = true
    @$el.addClass('active')

  deactivate: ->
    if @isActivated
      @dashboard.deactivate()
      @isActivated = false
      @$el.removeClass('active')

  destroy: ->
    @dashboard.destroy()
    this.remove()
    return false

  getUuid: ->
    return @dashboard.uuid

  onUpdateContentsCount: ->
    $.ajax
      url: "/profiling/dashboard/realtime_count/"
      type: 'POST'
      data:
        uuid: @getUuid()
      global: false
      success: (data) =>
        @updateBadge(data)
      dataType: "json"

  updateBadge: (data) =>
    @$el.find('i.badge').html(data["counters"]["enqueued_count"]).show()
    popoverText = "Total: " + data["counters"]["enqueued_count"] + " - Blocked: " + data["counters"]["blocked_count"]
    @$el.find('.badge-count-container i')[0].setAttribute("data-content", popoverText)
    window.load_popovers()

  copySession: (event) =>
    session = @session()
    body_before = document.body
    copySessionModal = new Monitoring.Views.SocialContents.CopySessionView(session: session).render()
    copySessionModal.bind 'onSuccess', (response) =>
      document.body.children.copy_session.remove()
      while (document.body.children.copy_session)
        document.body.children.copy_session.remove()
      document.getElementsByClassName("modal-backdrop")[0].remove()
    $($(copySessionModal.$el.find('.users'))).css('padding-left','10px')
    copySessionModal.show().appendTo("body")

  removeSession: (event) =>
    event.stopPropagation()
    swal({
        title: I18n.t('monitoring.dashboard.session.modal_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: I18n.t('monitoring.dashboard.session.s_yes'),
        cancelButtonText: I18n.t('monitoring.dashboard.session.s_cancel'),
        closeOnConfirm: true
      }, =>
        @eventAggregator.trigger('clickOnRemoveSession', @session())
      )

  restoreSession: (event) =>
    @eventAggregator.trigger('clickOnRestoreSession', @session(), => @trigger('destroyFromRestore'))

  cloneSession: (event) =>
    event.stopPropagation()
    this.$el.find('.dropdown-menu').click()
    session = @session()
    session.name = "#{@session.name}(cloned)"
    $.ajax
      url: "/monitoring/sessions/#{session.uuid}/clone"
      data: JSON.stringify({
        users_ids: [session.user_id]
      })
      type: 'POST'
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: (response) =>
        session = response.session
        @eventAggregator.trigger('sessionListChange')
        @eventAggregator.trigger('clickOnRestoreSession', session , => @trigger('destroyFromRestore'))

  session: =>
    @dashboard.session

  renameSession: (event) =>
    event.stopPropagation()
    this.$el.find('.dropdown-menu').click()
    @$el.editable(@_getEditableOptions())
    @$el.editable('toggle')
    @$el.find('.tab').tooltip({ 'placement': 'bottom' })

  onMouseLeaveDropdownMenu: ->
    @$el.find('.dropdown').removeClass('open')

  _iconClassByMode: (mode) ->
    classes = {'explore': 'fa fa-comments', 'review': 'fa fa-tags', 'analysis': 'fa fa-share-alt'}
    classes[mode]
